import React from 'react';

const Navbar = ({ 
  darkMode, 
  setDarkMode, 
  favorites, 
  showFavorites, 
  setShowFavorites,
  showStats,
  setShowStats,
  showPrivacy,
  setShowPrivacy,
  showTerms,
  setShowTerms,
  quoteHistory
}) => {
  const handleNavigation = (section) => {
    if (section === 'favorites') {
      setShowFavorites(true);
      setShowStats(false);
      setShowPrivacy(false);
      setShowTerms(false);
    } else if (section === 'stats') {
      setShowStats(true);
      setShowFavorites(false);
      setShowPrivacy(false);
      setShowTerms(false);
    } else if (section === 'privacy') {
      setShowPrivacy(true);
      setShowFavorites(false);
      setShowStats(false);
      setShowTerms(false);
    } else if (section === 'terms') {
      setShowTerms(true);
      setShowFavorites(false);
      setShowStats(false);
      setShowPrivacy(false);
    } else {
      setShowFavorites(false);
      setShowStats(false);
      setShowPrivacy(false);
      setShowTerms(false);
    }
  };

  return (
    <header className="header">
      <div className="header-brand">
        <h1>✨ Motivačné citáty</h1>
        <p className="header-subtitle">Inšpirujte sa každý deň</p>
      </div>
      
      <div className="header-controls">
        <button 
          onClick={() => handleNavigation('home')}
          className={`icon-button ${!showFavorites && !showStats && !showPrivacy && !showTerms ? 'active' : ''}`}
          title="Domov"
        >
          <span className="icon">🏠</span>
        </button>
        
        <button 
          onClick={() => handleNavigation('stats')}
          className={`icon-button ${showStats ? 'active' : ''}`}
          title="Štatistiky"
        >
          <span className="icon">📊</span>
          <span className="count">{quoteHistory?.length || 0}</span>
        </button>
        
        <button 
          onClick={() => handleNavigation('favorites')}
          className={`icon-button ${showFavorites ? 'active' : ''}`}
          title="Obľúbené citáty"
        >
          <span className="icon">❤️</span>
          <span className="count">{favorites.length}</span>
        </button>
        
        <button 
          onClick={() => handleNavigation('privacy')}
          className={`icon-button ${showPrivacy ? 'active' : ''}`}
          title="Ochrana súkromia"
        >
          <span className="icon">🔒</span>
        </button>
        
        <button 
          onClick={() => handleNavigation('terms')}
          className={`icon-button ${showTerms ? 'active' : ''}`}
          title="Podmienky používania"
        >
          <span className="icon">📋</span>
        </button>
        
        <button 
          onClick={() => setDarkMode(!darkMode)}
          className="icon-button"
          title={darkMode ? 'Prepnúť na svetlú tému' : 'Prepnúť na tmavú tému'}
        >
          <span className="icon">{darkMode ? '☀️' : '🌙'}</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
